import styles from './styles.module.scss';
import { GAME_CONFIG, getDifficultyAppearance } from '../../../game/helpers';
import { DifficultyLevel } from '../../../../shared/enums';
import CountBoxImage from '../../../../assets/images/metro/CountBox.svg';
import DiamondImage from '../../../../assets/images/Diamond.svg';
import classNames from 'classnames';
import { useGameData } from '../../../game/hooks/useGameData';
import { isUserCanReceivePoints, isUserReceivedPoints } from '../../../../shared/utils';
import { useWinEvent } from '../../../../hooks/useWinEvent';

interface IDifficultyGrid {
  className?: string;
  opened?: number;
  onSelectLevel: (level: DifficultyLevel) => void;
}

// TO-DO:
// Добавить проверку на возраст и тип учётки мос.ру(из постановки)
// Добавить проверку на isCompleted для уровня ЛЕГЕНДА

export const DifficultyGrid: React.FC<IDifficultyGrid> = ({ opened = 0, onSelectLevel, className }) => {
  const { userData, scoreData } = useGameData();

  // Доотправка евентов победы для игры метро из "localStorage".
  useWinEvent({
    eventId: '',
    gameCode: 'metro',
    userId: userData?.id || null,
  });

  return (
    <div className={classNames(styles.grid, className)}>
      {getDifficultyAppearance('metro').map((level, index: number) => {
        const { icon, difficultyLevel, isPoints } = level;
        const title = GAME_CONFIG['metro'].text.singular[difficultyLevel];
        return (
          <button
            className={classNames(styles.level, 'simple-btn', { [styles.disabled]: index > opened })}
            onClick={() => onSelectLevel(difficultyLevel)}
            key={index}
          >
            <img src={CountBoxImage} className={styles.box} alt="" />
            <div className={styles.content}>
              <img src={icon} alt={title} className={styles.icon}></img>
              <span className={styles.title}>{title}</span>
            </div>
            {isPoints && isUserCanReceivePoints(userData) && !isUserReceivedPoints(scoreData) && (
              <div className={styles.bubble}>
                <img src={DiamondImage} alt="diamond" className={styles.diamond} />
                <span className={styles.points}>{10}</span>
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
};
